import { Component, computed, inject, input, output } from '@angular/core'
import { CartItem, ProductKey, ProductType } from '@naturalcycles/shared'
import { SubscriptionService } from '@src/app/core/services/subscription.service.js'

@Component({
  selector: 'app-cart-item',
  templateUrl: './cart-item.component.html',
  styleUrls: ['./cart-item.component.scss'],
  standalone: false,
})
export class CartItemComponent {
  private subscriptionService = inject(SubscriptionService)

  protected item = input.required<CartItem>()
  protected iconColor = input<'default' | 'dark'>('default')
  protected showPrice = input<boolean>(true)
  protected optional = input<boolean>(false)
  protected selected = input<boolean>(false)
  protected titleModifier = input<string | undefined>()
  protected toggleSelected = output()
  protected ProductKey = ProductKey
  protected icon = computed(() => (this.iconColor() === 'default' ? 'check-prosecco' : 'check'))

  protected nextRenewalProduct = computed(() => {
    const { key } = this.item()
    return this.subscriptionService.getRenewalProductForRollingTrial(key)
  })

  protected isOuraDiscountItem = computed(() => this.item()?.key === ProductKey.OURA_RING_DISCOUNT)

  protected nextRenewalProductDuration = computed(() => {
    const nextRenewalProduct = this.nextRenewalProduct()
    if (nextRenewalProduct?.type !== ProductType.SUBSCRIPTION) return
    return this.subscriptionService.getDurationUnit(nextRenewalProduct)
  })
}
